import interceptorAxios from './InterceptorAxios';
const ServicioAfil ={
    procesarAfil(objeto){
        return interceptorAxios.post("/afil/procesar.json", objeto); 
     },
     paginacion(objeto){
        return interceptorAxios.post('/afil/paginacion_admin.json',objeto);
    }
}
export default ServicioAfil;